// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Models.tst template. 
// !!!!!! Do not modify this file or change will probably be lost !!!!!!
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import Validator from './Validator';
import MinMaxDTO from './MinMaxDTO';
import EntitySelectorDTO from './EntitySelectorDTO';

interface AwardTypeDataTableDTO extends EntitySelectorDTO { 
	id: number;
	order: number;
	code: string | null;
	name: string | null;
}

const AwardTypeDataTableDTO = {
    className: 'AwardTypeDataTableDTO',
    create: (initValues?: Partial<AwardTypeDataTableDTO> | Record<string, unknown> | null) => {
        return Object.assign(EntitySelectorDTO.create(),
        {
			id: 0,
			order: 0,
			code: "",
			name: "",
        },
        initValues);
    },
	id: 'id',
	order: 'order',
	code: 'code',
	name: 'name',
};

export default AwardTypeDataTableDTO;